var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 option-container d-flex align-center",class:{'w-full':_vm.$vuetify.breakpoint.xs}},[_c('v-btn',{staticClass:"camel-case option-btn",attrs:{"outlined":"","color":"primary"},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }